export default __webpack_public_path__ + "static/media/faviconGA.637f8c6c.ico";